import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  category: {
    backgroundColor: "#2E434D",
    color: "#FFF",
    fontSize: "14px",
  },
  mediaHome: {
    maxWidth: 426,
    height: 320,
    borderRadius: "24px",
    objectFit: "cover",
  },
  footer: {
    width: "100%",
    backgroundColor: "#E2E4E5",
    height: "40px",
    display: "flex",
    textAlign: "center",
    alignItems: "center",
  },
  title: {
    fontSize: 32,
    lineHeight: "50px",
    marginBottom: 20,
  },
  interestButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    gap: "24px",
  },
  whatsAppButton: {
    background: "rgba(253, 253, 253, 0.25)",
    border: "1px solid rgba(253, 253, 253, 1)",
    color: "white",
    "&:hover": {
      background: "white",
      border: "1px solid rgba(253, 253, 253, 1)",
      color: "black",
    },
  },
}));

export default useStyles;
